import React from 'react';
import Info from '../../info';

export default function BeforeCallsRightBottomPanel(props) {
  if (props.updateOrView === 'update') {
    return (
      <Info
        paragraphs={[
          APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.InfoPartOne,
          APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.InfoPartTwo,
        ]}
      />
    );
  } else {
    return <Info paragraphs={[APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.InfoPartOne]} />;
  }
}
